import React from 'react';
import { PageBanner } from '../components/PageBanner';
import { ContactSection } from '../components/ContactSection';
import { ReviewCTA } from '../components/ReviewCTA';
export function ContactPage() {
  return <>
      <PageBanner title="Contact Us" subtitle="We'd love to hear from you. Reach out to book or ask questions." backgroundImage="https://cdn.magicpatterns.com/uploads/jhnvyNTv6F4CCdtD6AQqF8/high-quality_image_of_a_woman_with_long,_neat_braids,_styled_elegantly._She_is_seated_in_a_confident_pose,_looking_slightly_over_her_shoulder._The_lighting_highlights_her_smooth_skin_and_detailed_braiding,_reinf_(2).jpg" data-id="element-510" />
      <ContactSection data-id="element-511" />
      <ReviewCTA data-id="element-512" />
    </>;
}